import styled from 'styled-components';

export const CAPTURE_WIDTH = 900;
export const CAPTURE_HEIGHT = 360;

// Off-viewport, fixed-dimension host. Uses visibility: hidden (never
// display: none) so recharts still lays out a real SVG with non-zero size.
export const CaptureHost = styled.div`
  position: fixed;
  top: 0;
  left: -100000px;
  width: ${CAPTURE_WIDTH}px;
  height: ${CAPTURE_HEIGHT}px;
  visibility: hidden;
  pointer-events: none;
  background: var(--white);
  z-index: -1;
`;
